const Famille = {
    text: 'Famille',
    link: '/famille',
    icon: 'icon-people', // fa fa-users icon-people
    fonctionnalite: 'FAMILLE', // fonctionnalite permet de gérer les droits dans la table habilitations
};

const Eleve = {
    text: 'Elève',
    link: '/eleve',
    icon: 'fa fa-user-o', // icon-graduation
    fonctionnalite: 'ELEVE', // fonctionnalite permet de gérer les droits dans la table habilitations
};

const Professeur = {
    text: 'Professeur',
    link: '/professeur',
    icon: 'icon-graduation', // fa fa-graduation-cap icon-pencil
    fonctionnalite: 'PROFESSEUR',
};

const Cours = {
    text: 'Cours',
    link: '/cours',
    icon: 'icon-book-open',
    fonctionnalite: 'COURS',
};

const Planning = {
    text: 'Planning',
    link: '/planning',
    icon: 'fa fa-calendar', // icon-calendar
    fonctionnalite: 'PLANNING',
    submenu: [
        {
            text: 'Professeur',
            link: '/planning/professeur',
            fonctionnalite: 'PLANNING_PROF',
        }, {
            text: 'Salle',
            link: '/planning/salle',
            fonctionnalite: 'PLANNING_SALLE',
        }
    ]
};

const Bulletin = {
    text: 'Bulletin',
    link: '/bulletin',
    icon: 'icon-badge',
    fonctionnalite: 'BULLETIN',
};

const Examens = {
    text: 'Examen',
    link: '/examens',
    icon: 'icon-notebook',
    fonctionnalite: 'EXAMEN'
};

const Courriel = {
    text: 'Mail',
    link: '/courriel',
    icon: 'icon-envelope',
    fonctionnalite: 'COURRIEL'
};

const Sms = {
    text: 'Sms',
    link: '/sms',
    icon: 'fa fa-mobile',
    fonctionnalite: 'SMS'
};

const Finance = {
    text: 'Finance',
    link: '/finances',
    icon: 'fa fa-eur',
    fonctionnalite: 'ADMINISTRATION',
    submenu: [
        {
            text: 'Paiement',
            link: '/administration/paiements',
        }, {
            text: 'Facture',
            link: '/administration/factures',
            // icon: 'file-invoice', // Non pris en compte car non déclaré dans ngx je pense
            fonctionnalite: 'FACTURATION',
        }, 
    ]
}
const Administration = {
    text: 'Administration',
    link: '/administration',
    icon: 'icon-pencil', // icon-settings
    fonctionnalite: 'ADMINISTRATION',
    submenu: [
        {
            text: 'Absence',
            link: '/administration/absences'
        }, /*{
            text: 'Courriel',
            link: '/administration/courriel',
        },*/ {
            text: 'Location',
            link: '/administration/locations'
        }, {
            text: 'Requêteur',
            link: '/administration/requeteur'
        }, {
            text: 'Accès famille',
            link: '/administration/acces_famille',
            fonctionnalite: 'LIEN_FAMILLE',
        }, {
            text: 'Rendez-vous',
            link: '/administration/rendez_vous',
            fonctionnalite: 'LIEN_FAMILLE',
        }
    ]
};

const Parametrage = {
    text: 'Paramétrage',
    link: '/parametrage',
    icon: 'icon-settings',
    fonctionnalite: 'PARAMETRAGE',
    submenu: [
        {
            text: 'Utilisateur',
            link: '/parametrage/utilisateurs',
        },
        {
            text: 'Liste',
            // link: '/parametrage/listes',
            submenu: [{
                text: 'Salle',
                link: '/parametrage/listes/salles'
            }, {
                text: 'Discipline',
                link: '/parametrage/listes/disciplines'
            }, {
                text: 'Cycle',
                link: '/parametrage/listes/cycles'
            }, {
                text: 'Niveaux',
                link: '/parametrage/listes/niveaux'
            }, {
                text: 'Materiel',
                link: '/parametrage/listes/materiels'
            }, {
                text: 'Duree',
                link: '/parametrage/listes/durees'
            }, {
                text: 'Parametre',
                link: '/parametrage/listes/parametres'
            }]
        },
        {
            text: 'Cursus',
            link: '/parametrage/cursus',
        },
        {
            text: 'Examen',
            link: '/parametrage/examens',
        },
        {
            text: 'Facturation',
            link: '/parametrage/facturation',
        },
        {
            text: 'Editique',
            // link: '/parametrage/editique',
            submenu: [{
                text: 'Paramétrage',
                link: '/parametrage/editique/parametrage'
            }, 
            {
                text: 'Document',
                link: '/parametrage/editique/document'
            }]
        },
        {
            text: 'Année',
            link: '/parametrage/annee',
        },
        {
            text: 'Courriel',
            link: '/parametrage/courriel',
        },
    ]
};

const MonCompte = {
    text: 'Mon compte',
    link: '/moncompte',
    icon: 'fa fa-user-circle', // icon-settings
};

const headingMain = {
    text: 'Navigation',
    heading: true
};

export const menu = [
    headingMain,
    Famille,
    Eleve,
    Professeur,
    Cours,
    Planning,
    Courriel,
    Sms,
    Bulletin,
    Examens,
    Finance,
    Administration,
    Parametrage,
    MonCompte,
];



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/core/menu/menu.ts